import { Flex, Text, CustomButton } from '@/components';
import styled from 'styled-components';
import modalImageFromLanding from '@/assets/modal-image-from-landing.png'; // Asumiendo que usas la misma imagen

// Redux
import { useSelector } from 'react-redux';

const ModalWrapper = styled(Flex)`
  max-width: 600px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  align-items: center; 
  text-align: center;
  flex-direction: row; 
  justify-content: center; 
  padding: 20px;
  background: white;
`;

const ImageContainer = styled.div`
  width: 100%; 
  display: flex;
  justify-content: center;
  margin-bottom: 10px; 
`;

const StyledImage = styled.img`
  width: 120px; 
  height: auto;
  margin-right: 20px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column; 
  align-items: flex-start;
`;

const StyledButton = styled(CustomButton)`
  padding: 12px 30px;
  margin-top: 20px;
  width: auto; // Ajusta esto según sea necesario
  justify-content: center;
  align-items: center;
`;

const ModalInfoTemp = ({ closeModal }) => {
  const { primaryColor } = useSelector(({ theme }) => theme);

  return (
    <ModalWrapper>
      <ImageContainer>
        <StyledImage src={modalImageFromLanding} alt="Modal from Landing" />
      </ImageContainer>
      <ContentWrapper>
        <Text
          color="#333"
          clave="Regístrate y o inicia sesión para poder visualizar tu documento."
          margin="0"
          textAlign="center"
        />
        <StyledButton
          bg={primaryColor}
          w="fit-content"
          mt="20px"
          action={() => closeModal()}
        >
          <Flex style={{ cursor: 'pointer' }}>
            <Text clave="accept" />
          </Flex>
        </StyledButton>
      </ContentWrapper>
    </ModalWrapper>
  );
};

export default ModalInfoTemp;